import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { IAction, IIntegration } from 'types';
import * as API from '../../api';
import * as Actions from './actions';
import { Integration } from './types';

export function* getIntegration({ payload }: IAction<Integration, { siteId: string; integrationId: string }>) {
  const { siteId, integrationId } = payload;

  try {
    const response: ApiResponse<IIntegration> = yield call(API.Integrations.getIntegration, siteId, integrationId);
    yield put(Actions.getIntegrationSucess(response.body));
  } catch (error: any) {
    yield put(Actions.getIntegrationError(error));
  }
}

export function* watchGetIntegration() {
  yield takeEvery(Integration.GET_INTEGRATION_REQUEST, getIntegration);
}

function* integrationSaga() {
  yield all([fork(watchGetIntegration)]);
}

export { integrationSaga };
